const emerging = {
    emergingArtists: "新進アーティスト",
    artists: "アーティスト",
    numberWorks: "作品数",
    artistComments:	"アーティストからのコメント",
}

module.exports = emerging;